import { render, staticRenderFns } from "./PlanInfo.vue?vue&type=template&id=52575fa3&"
import script from "./PlanInfo.vue?vue&type=script&lang=js&"
export * from "./PlanInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports